import { render, staticRenderFns } from "./template_2.vue?vue&type=template&id=6ff3ef3e&scoped=true"
import script from "./template_2.vue?vue&type=script&lang=js"
export * from "./template_2.vue?vue&type=script&lang=js"
import style0 from "./template_2.vue?vue&type=style&index=0&id=6ff3ef3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff3ef3e",
  null
  
)

export default component.exports